import { render, staticRenderFns } from "./Selections.vue?vue&type=template&id=2a0b02f4&scoped=true"
import script from "./Selections.vue?vue&type=script&lang=js"
export * from "./Selections.vue?vue&type=script&lang=js"
import style0 from "./Selections.vue?vue&type=style&index=0&id=2a0b02f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a0b02f4",
  null
  
)

export default component.exports